import { whoami } from "./auth";
import type { AppDispatch, RootState } from "../store";

export const UPDATE_ACCOUNT_REQUEST = "UpdateAccount.Request";
export const UPDATE_ACCOUNT_SUCCESS = "UpdateAccount.Success";
export const UPDATE_ACCOUNT_FAILURE = "UpdateAccount.Failure";

export function updateAccount(data: { email: string }) {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const { auth } = getState();
    dispatch({ type: UPDATE_ACCOUNT_REQUEST });
    try {
      const response = await fetch("/api/account", {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${(auth as any).token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      if (result.status === "success") {
        dispatch({ type: UPDATE_ACCOUNT_SUCCESS });
        dispatch(whoami() as any);
      } else {
        dispatch({ type: UPDATE_ACCOUNT_FAILURE, payload: result });
        throw new Error(result.message || "Update failed");
      }
    } catch (err) {
      dispatch({ type: UPDATE_ACCOUNT_FAILURE });
      throw err;
    }
  };
}
